import React, { PureComponent } from 'react';
import './login-frame.less';
import {CUSTOMIZED_MERCHANT_LIST} from '../../../../../tools/constants';
import {withRouter} from 'react-router-dom';

class LoginFrame extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            loginType: 'password',
            bgUrl: '',
            isCustomizedMerchant: false,
            loginMerchantInfo: {}
        };
    }

    componentDidMount() {
        const bg = document.getElementById('bg');
        const bgWrapper = document.getElementsByClassName('login-bg-v5')[0];
        const loginFrameWrapper = document.getElementsByClassName('login-frame-v5')[0];
        const search = this.props.history.location.search
        const merchantBelong = new URLSearchParams(search).get('merchantBelong');
        const loginMerchant = CUSTOMIZED_MERCHANT_LIST.find(item => item.merchantBelong === merchantBelong);
        if(loginMerchant) {
            this.setState({
                bgUrl: loginMerchant.bgURl,
                isCustomizedMerchant: true,
                loginMerchantInfo: loginMerchant
            }, () => {
                loginFrameWrapper.style.backgroundImage = `url(${this.state.loginMerchantInfo.preBgUrl})`;
                bgWrapper.style.backgroundImage = `url(${this.state.loginMerchantInfo.bgURl})`;
            });
            localStorage.setItem('merchantBelong', merchantBelong);
        } else {
            this.setState({
                bgUrl: 'https://oss.zhongbaounion.com/share/background/bg.jpg'
            })
            localStorage.removeItem('merchantBelong');
        }
        bg.onload = () => {
            bgWrapper.style.visibility = 'visible';
        }
    }

    render() {
        return (
            <div className='login-frame-v5'>
                <div className="login-bg-v5"></div>
                <img id="bg" src={this.state.bgUrl} />
                <div className='login'>
                    <div className='left'>
                        <div className="content-box">
                            <div className="text-box">
                                {
                                    this.state.isCustomizedMerchant
                                        ? <img className="desc-img" src={this.state.loginMerchantInfo.descUrl} alt=""/>
                                        : <img className="desc-img" src={require('../../../img/login-bg-desc.png')} alt=""/>
                                }
                                {/*<p className="title">让保险经营更简单</p>*/}
                                {/*<p className="desc">提供全链条数字化服务  成为保险经营者最信赖的伙伴</p>*/}
                            </div>
                        </div>
                    </div>
                    <div className='right'>
                        <div className='inputArea'>
                            {this.props.children}
                        </div>
                    </div>
                </div>
                <div className='footer'>
                    <div className="copyright">
                        {
                            this.state.loginMerchantInfo.merchantBelong === 'yjb'
                                ? 'Copyright© 2022 预见保网络科技有限公司'
                                : <span>力码科技&copy;2022</span>
                        }
                    </div>
                    {/*<div className="copyright">Copyright© 2017-2019 北京力码科技有限公司 京ICP备17058300号-1</div>*/}
                </div>
            </div>
        );
    }
};

export default withRouter(LoginFrame);
